export default __webpack_public_path__ + "static/media/montagne.fce6fc3e.png";